/**
 * @generated SignedSource<<27ef383f323326114b500be70d9bd04d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type agentSessionsMainQuery_query$data = {
  readonly agent_sessionQuery: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly agent: {
          readonly accountId: string;
          readonly name: string;
          readonly picture: AGG$URL;
        } | null;
        readonly agentAccountId: string | null;
        readonly associatedEntities: ReadonlyArray<{
          readonly __typename: "ConfluencePage";
          readonly id: string;
          readonly links: {
            readonly base: string | null;
            readonly webUi: string | null;
          } | null;
          readonly title: string | null;
        } | {
          readonly __typename: "JiraIssue";
          readonly id: string;
          readonly key: string;
          readonly webUrl: AGG$URL | null;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null> | null;
        readonly author: {
          readonly accountId: string;
          readonly name: string;
        } | null;
        readonly conversationChannel: {
          readonly createdAt: AGG$Long | null;
          readonly id: string | null;
          readonly interactionChannel: string | null;
          readonly interactionChannelAri: string | null;
          readonly isPinned: boolean | null;
          readonly isPlanning: boolean | null;
          readonly lastAgentMessageId: string | null;
          readonly lastAgentMessageStatus: string | null;
          readonly lastMessage: string | null;
          readonly lastMessageTimestamp: AGG$Long | null;
          readonly lastMessageType: ReadonlyArray<string | null> | null;
          readonly name: string | null;
          readonly pinnedAt: AGG$Long | null;
          readonly readStatus: boolean | null;
          readonly status: string | null;
        } | null;
        readonly convoAiAgentId: string | null;
        readonly expireTime: AGG$DateTime | null;
        readonly hasUnseenActivity: boolean | null;
        readonly id: string | null;
        readonly invocationType: string | null;
        readonly isRovo: boolean | null;
        readonly lastStateChangeAt: AGG$Long | null;
        readonly state: string | null;
        readonly stateReason: string | null;
        readonly studioAgent: {
          readonly name: string | null;
        } | null;
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
  readonly " $fragmentType": "agentSessionsMainQuery_query";
};
export type agentSessionsMainQuery_query$key = {
  readonly " $data"?: agentSessionsMainQuery_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"agentSessionsMainQuery_query">;
};

import agentSessionsMainPaginationQuery_graphql from './agentSessionsMainPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "agent_sessionQuery"
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "aqlQuery"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sharingContext"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": agentSessionsMainPaginationQuery_graphql
    }
  },
  "name": "agentSessionsMainQuery_query",
  "selections": [
    {
      "alias": "agent_sessionQuery",
      "args": [
        {
          "kind": "Variable",
          "name": "aqlQuery",
          "variableName": "aqlQuery"
        },
        {
          "kind": "Variable",
          "name": "shardingContext",
          "variableName": "sharingContext"
        },
        {
          "kind": "Literal",
          "name": "sort",
          "value": "lastStateChangeAt DESC"
        }
      ],
      "concreteType": "AgentSessionConnection",
      "kind": "LinkedField",
      "name": "__agentSessionsMain_agent_sessionQuery_connection",
      "plural": false,
      "selections": [
        {
          "concreteType": "AgentSessionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "AgentSession",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "hasUnseenActivity"
                },
                {
                  "kind": "ScalarField",
                  "name": "invocationType"
                },
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "state"
                },
                {
                  "kind": "ScalarField",
                  "name": "stateReason"
                },
                {
                  "kind": "ScalarField",
                  "name": "expireTime"
                },
                {
                  "kind": "ScalarField",
                  "name": "lastStateChangeAt"
                },
                {
                  "kind": "ScalarField",
                  "name": "isRovo"
                },
                {
                  "kind": "ScalarField",
                  "name": "agentAccountId"
                },
                {
                  "kind": "ScalarField",
                  "name": "convoAiAgentId"
                },
                {
                  "alias": "conversationChannel",
                  "concreteType": "AgentConversationChannel",
                  "kind": "LinkedField",
                  "name": "nativeConversationChannel",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "createdAt"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "interactionChannel"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "interactionChannelAri"
                    },
                    (v2/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "lastMessage"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "lastMessageTimestamp"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "lastMessageType"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "lastAgentMessageId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "lastAgentMessageStatus"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "readStatus"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "isPlanning"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "isPinned"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "pinnedAt"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "status"
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "name": "agent",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    (v2/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "picture"
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    (v2/*: any*/)
                  ]
                },
                {
                  "kind": "LinkedField",
                  "name": "studioAgent",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/)
                  ]
                },
                {
                  "kind": "LinkedField",
                  "name": "associatedEntities",
                  "plural": true,
                  "selections": [
                    (v4/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v1/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "key"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "webUrl"
                        }
                      ],
                      "type": "JiraIssue"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v1/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "title"
                        },
                        {
                          "concreteType": "ConfluencePageLinks",
                          "kind": "LinkedField",
                          "name": "links",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "base"
                            },
                            {
                              "kind": "ScalarField",
                              "name": "webUi"
                            }
                          ]
                        }
                      ],
                      "type": "ConfluencePage"
                    }
                  ]
                },
                (v4/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "cursor"
            }
          ]
        },
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            },
            {
              "kind": "ScalarField",
              "name": "endCursor"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "66193a4651d11da28fc8f4f4ca18ca29";

export default node;
